import React from 'react';

const AuthContext = React.createContext({

    authToken: null,
    hasValidatedPassphrase: false,
    setHasValidatedPassphrase: null,
    idAuth: null,
    isAuth: false,
    isMaster: false,
    isReady: false

});

export default AuthContext;